import React, { useState } from 'react';
import BadgesComponent from '../../../components/common/Badges';
import ToggleComponent from '../../../components/common/Toggle';
import CheckboxComponent from '../../../components/common/CheckBox';
import DataTable from '../../../components/common/CommonDataTable';
import './HealthfOverview.css'
import CoverageCardViewComponent from '../../../components/common/CoverageCardView';
import dayjs from 'dayjs';
interface objectType {
  facility: any;
  flow: string;
  }
const HealthFacilityViewUi = (props: objectType) =>{
    const { facility, flow } = props;
    let isGrampanchayat:boolean=false;
    const facilityDetails = facility;
    isGrampanchayat= facilityDetails?.isUsingGramPanchayat;
    const formatLinkedFacility = (data: any, type:string) => {
      if(type === 'linked-facility') {
        return data.map((item:any) => ({
          id: item.facility_id,
          name: item.facility_name,
          code: item.facility_code,
        }));
      } else if(type === 'village') {
        return data?.map((item:any) => ({
          id: item.village_id,
          name: item.village_name + " - "+item.village_code,
          code: item.village_code,
        }));
      }
      else if(type === 'gram_panchayat') {
        return data?.map((item:any) => ({
          id: item.gram_panchayat_id,
          name: item.gram_panchayat_name + " - "+item.gram_panchayat_code,
          code: item.gram_panchayat_code,
        }));
      }
     else if(type === 'ward') {
      return data?.map((item:any) => ({
        id: item.ward_id,
        name: item.ward_name +" - "+item.ward_code,
        code: item.ward_code,
      }));
    }
      else {
        return [];
      }
  }
  const formatDate = (dateString: string): string => {
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };
  return (
    <>
        <div className="overview health_facility">
        <BadgesComponent
          className="over-badge"
          badgeName="Facility Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <div>
            <label className="overview-details-label">Health Facility Name</label>
            <div className="overview-details-value">{facility.facility_name ? facility.facility_name : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Facility Category</label>
            <div className="overview-details-value">{facility.facility_category.length ? facility.facility_category.toString() : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Health Facility Type</label>
            <div className="overview-details-value">
              {facility.facility_type ? facility.facility_type : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Ownership</label>
            <div className="overview-details-value">
             {facility.owenership? facility.owenership : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">
              HFR ID
            </label>
            <div className="overview-details-value">
              {facility.hfr_id? facility.hfr_id : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Administrative Body</label>
            <div className="overview-details-value">{facility.admin_body ? facility.admin_body : '-'}</div>
          </div>
          <div>
            <label className="overview-details-label">Central Government Department</label>
            <div className="overview-details-value">{facility.central_govt_dept ? facility.central_govt_dept : '-'}</div>
          </div>
        </div>
      </div>
      <div className="overview">
        <BadgesComponent
          className="over-badge"
          badgeName="ABDM Facility Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <div>
            <label className="overview-details-label">Health Facility Type</label>
            <div className="overview-details-value">
            {facility.abdmDetails ? facility.abdmDetails.facility_type : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Ownership</label>
            <div className="overview-details-value">
              {facility.abdmDetails ? facility.abdmDetails.ownership : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Facility Name</label>
            <div className="overview-details-value">
              {facility.abdmDetails ? facility.abdmDetails.abdm_facility_name : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Facility Status</label>
            <div className="overview-details-value">
              {facility.abdmDetails ? facility.abdmDetails.status : '-'}
            </div>
          </div>
        </div>
      </div>

      <div className="overview">
        <BadgesComponent
          className="over-badge"
          badgeName="ABDM Location Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <div>
            <label className="overview-details-label">State</label>
            <div className="overview-details-value">
              {facility.abdmDetails ? `${facility.abdmDetails.state_name} - ${facility.abdmDetails.state_code}` : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">District Name</label>
            <div className="overview-details-value">
              {facility.abdmDetails ? `${facility.abdmDetails.district_name} - ${facility.abdmDetails.district_code}` : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Sub District Name</label>
            <div className="overview-details-value">
              {facility.abdmDetails ? `${facility.abdmDetails.sub_district_name} - ${facility.abdmDetails.sub_district_code}` : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Village /City/Town Name</label>
            <div className="overview-details-value">
              {facility.abdmDetails ? `${facility.abdmDetails.village_city_town_name} - ${facility.abdmDetails.village_city_town_code}` : '-' }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Address</label>
            <div className="overview-details-value">
              {facility.abdmDetails ? facility.abdmDetails.address : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Lattitude</label>
            <div className="overview-details-value">
              {facility.abdmDetails ? facility.abdmDetails.latitude : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Longitude</label>
            <div className="overview-details-value">
              {facility.abdmDetails ? facility.abdmDetails.longitude : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Pincode</label>
            <div className="overview-details-value">
              {facility.abdmDetails ? facility.abdmDetails.pincode : '-'}
            </div>
          </div>
        </div>
      </div>
      <div className="overview">
        <BadgesComponent
          className="over-badge"
          badgeName="Enrollment Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <div>
            <label className="overview-details-label">Date of Enrollment</label>
            <div className="overview-details-value">
              {facility.enrollment_dt ? formatDate(dayjs(facility.enrollment_dt).format('YYYY-MM-DD')) : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Effective From Date</label>
            <div className="overview-details-value">
              {facility.effective_from_dt ? formatDate(dayjs(facility.effective_from_dt).format('YYYY-MM-DD')) : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Status</label>
            <div className="overview-details-value">
             {facility.facility_status ? facility.facility_status : facility.status}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Sanctioned Bed Count</label>
            <div className="overview-details-value">
              {facility.sanctioned_bed_count? facility.sanctioned_bed_count : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Functional Bed Count</label>
            <div className="overview-details-value">
              {facility.functional_bed_count ? facility.functional_bed_count : '-'}
            </div>
          </div>
       </div>
      </div>

      <div className="overview">
        <BadgesComponent
          className="over-badge"
          badgeName="Hierarchy Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <div>
            <label className="overview-details-label">State</label>
            <div className="overview-details-value">
              {facility.state_name ? `${facility.state_name} - ${facility.state_code}` : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">District</label>
            <div className="overview-details-value">
              {facility.district_name ? `${facility.district_name} - ${facility.district_code}` : '-' }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Rural/Urban</label>
            <div className="overview-details-value rural_urban">
              {facility.urba_rural_name ? facility.urba_rural_name : '-'}
            </div>
          </div>
          {
          facility.urba_rural_name !== 'rural' &&
            <div>
              <label className="overview-details-label">ULB</label>
              <div className="overview-details-value">
                {facility.ulb_name? `${facility.ulb_name} - ${facility.ulb_code}` : '-'}
              </div>
            </div>
          }         
          <div>
            <label className="overview-details-label">Sub District</label>
            <div className="overview-details-value">
              {facility.sub_district_name ? `${facility.sub_district_name} - ${facility.sub_district_code}` : '-' }
            </div>
          </div>
          {
            facility.urba_rural_name !== 'urban' &&
            <div>
              <label className="overview-details-label">Block</label>
              <div className="overview-details-value">
              {facility.block_name ? `${facility.block_name} - ${facility.block_code}` : '-' }
              </div>
            </div>
          }
          <div>
            <label className="overview-details-label">Health Block</label>
            <div className="overview-details-value">
              {facility.health_block ? facility.health_block : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">Sub Division</label>
            <div className="overview-details-value">
              {facility.sub_division ? facility.sub_division : '-'}
            </div>
          </div>
          {
            facility.urba_rural_name !== 'urban' &&
            <div>
              <label className="overview-details-label">{`${isGrampanchayat?'Gram Panchayat / ADC Village':"Village"}`}</label>
              <div className="overview-details-value">
              {`${isGrampanchayat?(facility?.gram_panchayat_name ? `${facility?.gram_panchayat_name} - ${facility?.gram_panchayat_code}` : '-'):(facility.village_name ? `${facility.village_name} - ${facility.village_code}` : '-')}`}
              </div>
            </div>
          }
          {
            facility.urba_rural_name !== 'rural' &&
              <div>
                <label className="overview-details-label">Ward</label>
                <div className="overview-details-value">
                {facility.ward_name ? `${facility.ward_name} - ${facility.ward_code}` : '-'}
                </div>
              </div>
          }
          <div>
            <label className="overview-details-label">Parlimentary</label>
            <div className="overview-details-value">
              {facility.pac_name ? facility.pac_name : '-'}
            </div>
          </div>
          <div>
            <label className="overview-details-label">LAC 1</label>
            <div className="overview-details-value">
              {facility.lac_name ? facility.lac_name : '-'}
            </div>
          </div>
        </div>
      </div>
      <div className='overview'>
      <div className="upgrade_coverage">
          <BadgesComponent
            className="over-badge"
            badgeName="Coverage Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details-upgrade">
            <div className="upgrade_coverage_details_page">
              {facility.urba_rural_name === 'rural' && (
                <div className='coverage_rural_facility_village'>
                  <div className='coverage_rural_facility'>
                     {
                      <CoverageCardViewComponent listItems={formatLinkedFacility(facility.linkedFacilitiesRural, 'linked-facility')}
                       labelforCoverage={'Linked Facilities'}   />
                     }
                    </div>
                    <div className='coverage_urban_ward'>
                    {
                      <CoverageCardViewComponent listItems={formatLinkedFacility(facility.linkedWardRural, 'ward')} 
                       labelforCoverage={'Linked Wards'} />
                    }
                  </div>
                  <div className='coverage_rural_village'>
                    {
                      isGrampanchayat?
                      <CoverageCardViewComponent listItems={formatLinkedFacility(facility.linkedGramPanchayatRural, 'gram_panchayat')} 
                      labelforCoverage={'Linked Gram Panchayats / ADC Villages'} />
                      :
                      <CoverageCardViewComponent listItems={formatLinkedFacility(facility.linkedVillageRural, 'village')} 
                      labelforCoverage={'Linked Villages'} />
                    }
                  </div>
                </div>
              )}
              {facility.urba_rural_name !== 'rural' && (
                <div className='coverage_urban_facility_ward'>
                  <div className='coverage_urban_facility'>
                      {
                        <CoverageCardViewComponent listItems={formatLinkedFacility(facility.linkedFacilitiesUrban, 'linked-facility')}
                          labelforCoverage={'Linked Facilities'}  />
                      }
                  </div>
                  <div className='coverage_urban_ward'>
                    {
                      <CoverageCardViewComponent listItems={formatLinkedFacility(facility.linkedWardRural, 'ward')} 
                       labelforCoverage={'Linked Wards'} />
                    }
                  </div>
                  <div className='coverage_rural_village'>
                    {
                      isGrampanchayat?
                      <CoverageCardViewComponent listItems={formatLinkedFacility(facility.linkedGramPanchayatRural, 'gram_panchayat')} 
                      labelforCoverage={'Linked Gram Panchayats / ADC Villages'} />
                      :
                      <CoverageCardViewComponent listItems={formatLinkedFacility(facility.linkedVillageRural, 'village')} 
                      labelforCoverage={'Linked Villages'} />
                    }
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>  
    </>
  );
}

export default HealthFacilityViewUi;


